import { useState, useEffect } from "react";
import Order from "../../../actions/order";
import Notify from "../../../components/customHelpers/Notify";
import { statues } from "../../../utils/utils";

export const UpdateOrderManagement = () => {
  const { NotifyMessage } = Notify();
  const { viewOrderProducts } = Order();
  const [orders, setOrders] = useState([]);

  const getAllOrders = () => {
    viewOrderProducts().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.orders) {
        setOrders(data.orders);
      }
    });
  };

  const addPendingOrderLocally = (newItem) => {
    setOrders((prevOrders) => {
      let updatedOrders = [...prevOrders];
      const { sku, quantity, status, orderId } = newItem;

      // Find an existing order with the same id
      const existingOrderIndex = updatedOrders.findIndex(
        (order) => order.id === orderId
      );

      if (existingOrderIndex !== -1) {
        // Order with matching id exists
        const order = updatedOrders[existingOrderIndex];
        const existingProductIndex = order.orderProducts.findIndex(
          (p) => p.sku === sku
        );

        if (existingProductIndex !== -1) {
          // Product exists in orderProducts, update quantity
          updatedOrders[existingOrderIndex].orderProducts[
            existingProductIndex
          ].quantity =
            Number(
              updatedOrders[existingOrderIndex].orderProducts[
                existingProductIndex
              ].quantity
            ) + Number(quantity);
        } else {
          // Add new product to orderProducts
          updatedOrders[existingOrderIndex].orderProducts.push({
            sku,
            quantity: Number(quantity),
            status,
          });
        }
      } else {
        // No order with matching id, create new order
        updatedOrders.push({
          id: orderId,
          orderProducts: [
            {
              sku,
              quantity: Number(quantity),
              status,
            },
          ],
          status,
        });
      }

      return updatedOrders;
    });
  };

  const removeQuantityLocally = (sku, quantity, orderId) => {
    setOrders((prevOrders) => {
      let updatedOrders = [...prevOrders];

      // Find the order with the matching id
      const orderIndex = updatedOrders.findIndex(
        (order) => order.id === orderId
      );

      if (orderIndex !== -1) {
        const order = updatedOrders[orderIndex];
        const productIndex = order.orderProducts.findIndex(
          (p) => p.sku === sku
        );

        if (productIndex !== -1) {
          // Reduce the quantity of the matching product
          order.orderProducts[productIndex].quantity = Math.max(
            0,
            Number(order.orderProducts[productIndex].quantity) -
              Number(quantity)
          );

          // If quantity is 0, remove the product from orderProducts
          if (order.orderProducts[productIndex].quantity === 0) {
            order.orderProducts.splice(productIndex, 1);
          }

          // If no products remain in the order, remove the order
          if (order.orderProducts.length === 0) {
            updatedOrders.splice(orderIndex, 1);
          }
        }
      }

      return updatedOrders;
    });
  };

  const filterOrdersByProductId = (productId) => {
    return orders
      .filter((order) =>
        order.orderProducts.some((product) => product.sku === productId)
      )
      .map((order) => {
        const totalQuantity = order.orderProducts
          .filter((product) => product.sku === productId)
          .reduce(
            (total, product) => total + parseInt(product.quantity, 10),
            0
          );

        return {
          status: order.status,
          totalQuantity: totalQuantity,
        };
      });
  };

  const groupByStatusAndSumQuantities = (filteredResults) => {
    const groupedResults = {};

    const possibleStatuses = ["Ordered", "Pending"];
    possibleStatuses.forEach((status) => {
      groupedResults[status] = 0;
    });

    filteredResults.forEach((result) => {
      if (groupedResults[result.status] !== undefined) {
        groupedResults[result.status] += result.totalQuantity;
      }
    });

    return Object.keys(groupedResults).map((status) => ({
      status: status,
      totalQuantity: groupedResults[status],
    }));
  };

  useEffect(() => {
    getAllOrders();
  }, []);

  return {
    orders,
    getAllOrders,
    filterOrdersByProductId,
    groupByStatusAndSumQuantities,
    addPendingOrderLocally,
    removeQuantityLocally,
  };
};
